import React from 'react';
import {NavTabs} from '~/components/Tabs';
import {appAdsLinks} from '~/modules/AppAds';
import {useAbility} from '~/lib/ability';
import {AppAdsAbility} from '~/modules/AppAds/ability';

export const AppAdsNavigation = () => {
    const ability = useAbility(AppAdsAbility);

    const tabs = [{
        children: 'All app-ads.txt lines',
        to: appAdsLinks.appAds()
    }];

    if (ability.canViewMissingLines()) {
        tabs.push({
            children: 'Missing lines',
            to: appAdsLinks.missingLines()
        });
    }

    if (ability.canViewMismatchedLines()) {
        tabs.push({
            children: 'Mismatched lines',
            to: appAdsLinks.mismatchedLines()
        });
    }

    if (ability.canViewDownloadHistory()) {
        tabs.push({
            children: 'Download history',
            to: appAdsLinks.downloadHistory()
        });
    }

    return <NavTabs tabs={tabs}/>;
};
